import { Button } from "@/components/Button";
import { cn, getSizedImage } from "@/helpers/utils";
import React from "react";
import { PortalAd } from "./types";

type AdProps = {
  ad: PortalAd;
  onClick: () => void;
  btnCopy: string;
  btnClass: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const Ad = ({
  ad,
  className,
  onClick,
  btnCopy,
  btnClass,
  ...rest
}: AdProps) => {
  return (
    <div
      className={cn(
        `relative overflow-hidden rounded-md border border-solid border-primary-200 bg-blue-200`,
        className
      )}
      {...rest}
    >
      <div className="relative z-10 p-4 sm:h-full sm:p-6">
        <div className="flex h-full max-w-[67%] flex-col justify-between gap-y-3 lg:max-w-[68%]">
          <div>
            <h2
              className="mb-1 text-sm font-bold text-black sm:mb-2 sm:text-md"
              dangerouslySetInnerHTML={{ __html: ad.title }}
            ></h2>
            <p className="mb-0 text-[10px] sm:text-sm">{ad.description}</p>
          </div>
          <Button
            onClick={onClick}
            className={`${btnClass} hidden h-auto max-w-fit border-0 text-xs leading-[14px] sm:block`}
          >
            {btnCopy}
          </Button>
        </div>
        <picture>
          <source media="(min-width: 640px)" srcSet={ad.image.desktop.src} />
          <img
            src={ad.image.mobile.src}
            alt={ad.image.mobile?.alt}
            className="absolute left-0 top-0 -z-10 h-full w-full object-cover object-right"
            loading="eager"
          />
        </picture>
      </div>
      <Button
        onClick={onClick}
        className={`${btnClass} h-10 w-full rounded-se-none rounded-ss-none text-sm sm:hidden`}
      >
        {btnCopy}
      </Button>
    </div>
  );
};
